import {sanitizeObject} from "../helpers/sanitizers";

export default (confirmationDetails) => {
    return sanitizeObject(confirmationDetails);
};
